import { render, staticRenderFns } from "./FreeTrial.vue?vue&type=template&id=6fcc77d0&scoped=true"
import script from "./FreeTrial.vue?vue&type=script&lang=js"
export * from "./FreeTrial.vue?vue&type=script&lang=js"
import style0 from "./FreeTrial.vue?vue&type=style&index=0&id=6fcc77d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc77d0",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
